let about;

about = (() => {
  about.prototype.pressCarousel = function() {
    if (this.$pressObj.length > 0) {
      return setInterval(
        (_this => () => {
          let active;
          let activeDot;
          active = $(".press-obj.visible");
          activeDot = $(".dot-list li.active");
          active.removeClass("visible");
          activeDot.removeClass("active");
          return setTimeout(
            () => {
              if (active.next().length >= 1) {
                active.next().addClass("visible");
                return activeDot.next().addClass("active");
              } else {
                $($(".press-obj")[0]).addClass("visible");
                return $($(".dot-list li")[0]).addClass("active");
              }
            },
            500,
          );
        })(this),
        6000,
      );
    }
  };

  function about() {
    this.$pressObj = $(".press-obj");
    this.pressCarousel();
  }

  return about;
})();

export default about;
